import { useCallback, useEffect, useState } from "react";
import { Workflow } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { Card } from "@/components/Ui";
import { Switch } from "@/components/ui/switch";

const runText = (r) => (r ? `Ultima esecuzione ${fmtDateTime(r.at)} · ${Object.entries(r).filter(([k]) => k !== "at").map(([k, v]) => `${k.replace("_", " ")}: ${v}`).join(" · ")}` : "Non ancora eseguito");

export function AutomationsCard() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/integrations/automations").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (a, v) => {
    try { await api.put(`/integrations/automations/${a.key}`, { enabled: v }); toast.success(v ? "Automatismo attivo" : "Automatismo sospeso"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card className="p-5 xl:col-span-2" data-testid="automations-card">
      <p className="font-heading font-semibold text-slate-900 flex items-center gap-2 mb-3"><Workflow className="h-4 w-4 text-sky-600" />Automatismi</p>
      <ul className="divide-y divide-slate-100">
        {items.map((a) => (
          <li key={a.key} className="py-3 flex items-center gap-4" data-testid={`automation-${a.key}`}>
            <div className="flex-1">
              <p className="text-sm text-slate-900">{a.label}</p>
              <p className="text-[11px] text-slate-500">{runText(a.last_run)}</p>
            </div>
            <span className={`text-xs font-medium ${a.enabled ? "text-emerald-700" : "text-amber-700"}`}>{a.enabled ? "Attivo" : "Sospeso"}</span>
            <Switch checked={a.enabled} onCheckedChange={(v) => toggle(a, v)} data-testid={`automation-toggle-${a.key}`} />
          </li>
        ))}
      </ul>
    </Card>
  );
}
